import { useI18n }            from '../../../../shared/i18n/useI18n.js';
import { useProductStrings }  from '../../../../shared/i18n/useProductStrings.js';

import { Button }             from '../../../../shared/ui/Button/Button.jsx';
import { HeartButton }        from '../../../../shared/ui/HeartButton/HeartButton.jsx';
import { Plan }               from '../../../../shared/ui/icons/Plan.jsx';
import { Tooltip }            from '../../../../shared/ui/Tooltip/Tooltip.jsx';

export function FavoritesAction({ 
  product,
  context,
}) {
	const { t } = useI18n();
	const getProductsCategoryString = useProductStrings();

  const {
    buttonClass,
    size='medium',
    variant="ghost",
    cta = false,
		isFavorite,
		toggleFavorite,
	} = context;

	const idOriginal =
		product?.id_original ?? product.cms_product_name ?? product?.id_cad ?? null;

	return (
		<Tooltip
			title={`${getProductsCategoryString('add_to_favorites', product.product_category, { id: idOriginal })}`}
			placement="top"
			disableOnMobile
		>
			{/* <Button
				type="button"
				size={size}
				variant={variant}
        cta={cta}
				onClick={(e) => {
					e.stopPropagation();
					handleClick();
				}}
				onTouchEnd={(e) => e.stopPropagation()}
				aria-label={t('favorites.add')}
			> */}
				<HeartButton 
          isActive={isFavorite(product.uuid)}
          onToggle={() => toggleFavorite(product.uuid)}
          size={size}
        />
			{/* </Button> */}
		</Tooltip>
	);
}